import { render, staticRenderFns } from "./TableFiltrable.vue?vue&type=template&id=4a13f186&scoped=true"
import script from "./TableFiltrable.vue?vue&type=script&lang=js"
export * from "./TableFiltrable.vue?vue&type=script&lang=js"
import style0 from "./TableFiltrable.vue?vue&type=style&index=0&id=4a13f186&prod&scoped=true&lang=css"
import style1 from "./TableFiltrable.vue?vue&type=style&index=1&id=4a13f186&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a13f186",
  null
  
)

export default component.exports